(() => {
  'use strict';

  /* =========================================
     必須設定
  ========================================= */

  const CONFIG = {
    launchTime: '2026-07-26T20:00:00+09:00',

    /*
     商品URLが
     /products/photoshop-shido-basic
     なら、ハンドルは
     photoshop-shido-basic
    */
  productHandles: [
    'shido-no-sho',
    'archive-723'
  ],

  lockedButtonText: '7/26（日）20:00 販売開始'
};

  const launchTimestamp = new Date(CONFIG.launchTime).getTime();

  if (Number.isNaN(launchTimestamp)) {
    console.error(
      '[PS Launch Gate] 販売開始日時の指定が正しくありません。'
    );
    return;
  }

  let intervalId = null;
  let observer = null;
  let observerScheduled = false;

  /* =========================================
     基本判定
  ========================================= */

  function getRemainingTime() {
    return launchTimestamp - Date.now();
  }

  function isBeforeLaunch() {
    return getRemainingTime() > 0;
  }

  function getCurrentProductHandle() {
    const match = window.location.pathname.match(
      /^\/products\/([^/?#]+)/
    );

    return match
      ? decodeURIComponent(match[1])
      : '';
  }

  function isTargetProductPage() {
    const currentHandle = getCurrentProductHandle();

    return CONFIG.productHandles.includes(currentHandle);
  }

  function pad(number) {
    return String(number).padStart(2, '0');
  }

  /* =========================================
     カウントダウン
  ========================================= */

  function getCountdownParts(remaining) {
    const safeRemaining = Math.max(0, remaining);

    return {
      days: Math.floor(
        safeRemaining / (1000 * 60 * 60 * 24)
      ),

      hours: Math.floor(
        (safeRemaining / (1000 * 60 * 60)) % 24
      ),

      minutes: Math.floor(
        (safeRemaining / (1000 * 60)) % 60
      ),

      seconds: Math.floor(
        (safeRemaining / 1000) % 60
      )
    };
  }

  function updateCountdownElements(remaining) {
    const parts = getCountdownParts(remaining);

    document
      .querySelectorAll('[data-launch-days]')
      .forEach((element) => {
        element.textContent = pad(parts.days);
      });

    document
      .querySelectorAll('[data-launch-hours]')
      .forEach((element) => {
        element.textContent = pad(parts.hours);
      });

    document
      .querySelectorAll('[data-launch-minutes]')
      .forEach((element) => {
        element.textContent = pad(parts.minutes);
      });

    document
      .querySelectorAll('[data-launch-seconds]')
      .forEach((element) => {
        element.textContent = pad(parts.seconds);
      });

    document
      .querySelectorAll('[data-product-countdown]')
      .forEach((element) => {
        element.textContent =
          `${pad(parts.days)}日 ` +
          `${pad(parts.hours)}時間 ` +
          `${pad(parts.minutes)}分 ` +
          `${pad(parts.seconds)}秒`;
      });
  }

  function updateCountdownAreas(beforeLaunch) {
    document
      .querySelectorAll('[data-launch-area]')
      .forEach((area) => {
        const beforeArea = area.querySelector(
          '[data-launch-before]'
        );

        const afterArea = area.querySelector(
          '[data-launch-after]'
        );

        if (beforeArea) {
          beforeArea.hidden = !beforeLaunch;
        }

        if (afterArea) {
          afterArea.hidden = beforeLaunch;
        }
      });
  }

  /* =========================================
     LP購入ボタン
  ========================================= */

  function lockLpButton(button) {
    if (!button.dataset.launchOriginalText) {
      button.dataset.launchOriginalText =
        button.textContent.trim();
    }

    if (
      button.tagName === 'A' &&
      button.hasAttribute('href') &&
      !button.dataset.launchOriginalHref
    ) {
      button.dataset.launchOriginalHref =
        button.getAttribute('href');
    }

    button.classList.add('is-launch-locked');
    button.setAttribute('aria-disabled', 'true');
    button.setAttribute('tabindex', '-1');
    button.textContent = CONFIG.lockedButtonText;
  }

  function unlockLpButton(button) {
    button.classList.remove('is-launch-locked');
    button.removeAttribute('aria-disabled');
    button.removeAttribute('tabindex');

    if (button.dataset.launchOriginalText) {
      button.textContent =
        button.dataset.launchOriginalText;
    }

    if (
      button.tagName === 'A' &&
      button.dataset.launchOriginalHref
    ) {
      button.setAttribute(
        'href',
        button.dataset.launchOriginalHref
      );
    }
  }

  function updateLpButtons(beforeLaunch) {
    document
      .querySelectorAll('[data-launch-purchase]')
      .forEach((button) => {
        if (beforeLaunch) {
          lockLpButton(button);
        } else {
          unlockLpButton(button);
        }
      });
  }

  /* =========================================
     商品ページの購入フォーム
  ========================================= */

  function getProductForms() {
    return Array.from(
      document.querySelectorAll(
        'form[action*="/cart/add"]'
      )
    );
  }

  function getProductPurchaseElements() {
    const selectors = [
      'form[action*="/cart/add"] button[type="submit"]',
      'form[action*="/cart/add"] input[type="submit"]',
      'product-form button[type="submit"]',
      '.shopify-payment-button',
      '.shopify-payment-button__button',
      '[data-shopify="payment-button"]'
    ];

    return Array.from(
      document.querySelectorAll(selectors.join(','))
    );
  }

function createProductLaunchNotice() {
  const notice = document.createElement('div');

  notice.className = 'ps-product-launch-notice';
  notice.setAttribute(
    'data-product-launch-notice',
    ''
  );

  notice.innerHTML = `
    <p class="ps-product-launch-notice__label">
      LINE登録者限定・先行販売
    </p>

    <p class="ps-product-launch-notice__title">
      7月26日（日）20:00 販売開始
    </p>
  `;

  return notice;
}

  function addProductLaunchNotice() {
    if (
      document.querySelector(
        '[data-product-launch-notice]'
      )
    ) {
      return;
    }

    const productForm =
      document.querySelector('product-form') ||
      document.querySelector(
        'form[action*="/cart/add"]'
      );

    if (!productForm) {
      return;
    }

    const notice = createProductLaunchNotice();

    productForm.insertAdjacentElement(
      'beforebegin',
      notice
    );
  }

  function removeProductLaunchNotice() {
    document
      .querySelectorAll(
        '[data-product-launch-notice]'
      )
      .forEach((notice) => {
        notice.remove();
      });
  }

function lockProductPage() {
  if (!isTargetProductPage()) {
    return;
  }

  /*
   * Dawnの商品購入エリアを確実に隠すため、
   * bodyへ販売前専用クラスを付ける
   */
  document.body.classList.add(
    'ps-launch-product-locked'
  );

  getProductForms().forEach((form) => {
    form.dataset.launchLocked = 'true';
  });

  getProductPurchaseElements().forEach((element) => {
    element.classList.add('ps-launch-hidden');
    element.setAttribute('aria-hidden', 'true');

    if (
      element instanceof HTMLButtonElement ||
      element instanceof HTMLInputElement
    ) {
      element.disabled = true;
    }
  });

  addProductLaunchNotice();
}

function unlockProductPage() {
  if (!isTargetProductPage()) {
    return;
  }

  /*
   * 販売開始時刻になったらクラスを外し、
   * Dawnの購入ボタンを再表示する
   */
  document.body.classList.remove(
    'ps-launch-product-locked'
  );

  getProductForms().forEach((form) => {
    delete form.dataset.launchLocked;
  });

  getProductPurchaseElements().forEach((element) => {
    element.classList.remove('ps-launch-hidden');
    element.removeAttribute('aria-hidden');

    if (
      element instanceof HTMLButtonElement ||
      element instanceof HTMLInputElement
    ) {
      element.disabled = false;
    }
  });

  removeProductLaunchNotice();
}

  function updateProductPage(beforeLaunch) {
    if (!isTargetProductPage()) {
      return;
    }

    if (beforeLaunch) {
      lockProductPage();
    } else {
      unlockProductPage();
    }
  }

  /* =========================================
     販売前のクリック・送信をブロック
  ========================================= */

  function blockLockedClick(event) {
    if (!isBeforeLaunch()) {
      return;
    }

    const lpButton = event.target.closest(
      '[data-launch-purchase]'
    );

    if (lpButton) {
      event.preventDefault();
      event.stopImmediatePropagation();
      return;
    }

    if (!isTargetProductPage()) {
      return;
    }

    const purchaseElement = event.target.closest(
      [
        'form[action*="/cart/add"] button',
        'form[action*="/cart/add"] input[type="submit"]',
        '.shopify-payment-button',
        '.shopify-payment-button__button',
        '[data-shopify="payment-button"]'
      ].join(',')
    );

    if (purchaseElement) {
      event.preventDefault();
      event.stopImmediatePropagation();
    }
  }

  function blockLockedSubmit(event) {
    if (
      !isBeforeLaunch() ||
      !isTargetProductPage()
    ) {
      return;
    }

    const form = event.target;

    if (
      form instanceof HTMLFormElement &&
      form.matches('form[action*="/cart/add"]')
    ) {
      event.preventDefault();
      event.stopImmediatePropagation();
    }
  }

  /* =========================================
     状態更新
  ========================================= */

  function updateLaunchState() {
    const remaining = getRemainingTime();
    const beforeLaunch = remaining > 0;

    updateCountdownAreas(beforeLaunch);
    updateLpButtons(beforeLaunch);
    updateProductPage(beforeLaunch);

    if (beforeLaunch) {
      updateCountdownElements(remaining);
      return;
    }

    if (intervalId !== null) {
      window.clearInterval(intervalId);
      intervalId = null;
    }

    if (observer) {
      observer.disconnect();
      observer = null;
    }
  }

  /* =========================================
     動的に再描画される購入ボタンへの対応
  ========================================= */

  function startObserver() {
    observer = new MutationObserver(() => {
      if (observerScheduled) {
        return;
      }

      observerScheduled = true;

      window.requestAnimationFrame(() => {
        observerScheduled = false;

        if (isBeforeLaunch()) {
          updateProductPage(true);
        }
      });
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  }

  /* =========================================
     初期化
  ========================================= */

  function initialize() {
    document.addEventListener(
      'click',
      blockLockedClick,
      true
    );

    document.addEventListener(
      'submit',
      blockLockedSubmit,
      true
    );

    updateLaunchState();

    if (isBeforeLaunch()) {
      intervalId = window.setInterval(
        updateLaunchState,
        1000
      );

      startObserver();
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      initialize
    );
  } else {
    initialize();
  }
})();
